module.exports = __webpack_public_path__ + "media/utility-icons/truv-verified-mark-ad95d686.svg";